import './social.css'

const SocialBtn = ({link, icon}) => {

      if(link === '') return 

      return (
            <a href={link} className="btn_social" target="_blank" rel="noreferrer">{icon}</a>
      )
}

export default SocialBtn
